// TODO: Deprecated. Remove this file when video-controller.js is removed.
const DONE_BUTTON_ID = 'Done Action Item Button';
const IS_DISABLED = 'is-disabled';

// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated Deprecated: Do Not Use. To Be Removed with `video-controller.js`
 */
export function enableDoneButtonIfLastIncompleteItem() {
  let doneButton = document.getElementById(DONE_BUTTON_ID);
  if (doneButton) {
    doneButton.classList.remove(IS_DISABLED);
  }
}
